import { render, staticRenderFns } from "./ControlAccessCard.vue?vue&type=template&id=44ac8597&"
import script from "./ControlAccessCard.vue?vue&type=script&lang=js&"
export * from "./ControlAccessCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports